module.exports = "/_next/static/images/cubik-partners-2399153758b49f8eaeedef06cfdc373d.jpg";